/* Load once from layout/theme.liquid, not inside the Ajax cart template. */
(function () {
  if (window.qbCartDrawerInstalled) return;
  window.qbCartDrawerInstalled = true;

  const root =
    window.Shopify && Shopify.routes
      ? Shopify.routes.root
      : '/';

  const formSelector =
    '#slideout-ajax-cart .qb-drawer-cart-form';

  let noteDraft = null;
  let noteTimer;
  let noteQueue = Promise.resolve();
  let promoBusy = false;
  let checkoutBusy = false;
  let promoDraft = '';
  let promoMessage = '';
  let noteMessage = '';

  function currentForm() {
    return document.querySelector(formSelector);
  }

  function paint() {
    const form = currentForm();
    if (!form) return;

    const note = form.querySelector('.qb-cart-note');

    if (
      note &&
      noteDraft !== null &&
      note.value !== noteDraft
    ) {
      note.value = noteDraft;
    }

    const noteStatus =
      form.querySelector('.qb-note-status');

    if (
      noteStatus &&
      noteStatus.textContent !== noteMessage
    ) {
      noteStatus.textContent = noteMessage;
    }

    const promo =
      form.querySelector('.qb-promo-input');

    if (promo && promo.value !== promoDraft) {
      promo.value = promoDraft;
    }

    const status =
      form.querySelector('.qb-promo-status');

    if (
      status &&
      status.textContent !== promoMessage
    ) {
      status.textContent = promoMessage;
    }

    const apply =
      form.querySelector('.qb-promo-apply');

    if (apply) {
      apply.disabled = promoBusy || checkoutBusy;
    }

    const checkout =
      form.querySelector('[name="checkout"]');

    if (checkout) {
      checkout.disabled = promoBusy || checkoutBusy;
    }
  }

  async function updateCart(body) {
    const response = await fetch(
      root + 'cart/update.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(body)
      }
    );

    const cart = await response.json();

    if (!response.ok || cart.status >= 400) {
      throw new Error(
        typeof cart.description === 'string'
          ? cart.description
          : 'Unable to update your cart. Please try again.'
      );
    }

    return cart;
  }

  function saveNote(value) {
    noteMessage = 'Saving note…';
    paint();

    const request = noteQueue
      .catch(function () {})
      .then(function () {
        return updateCart({ note: value });
      });

    noteQueue = request;

    request
      .then(function () {
        if (value === noteDraft) {
          noteMessage = 'Note saved.';
        }

        paint();
      })
      .catch(function (error) {
        noteMessage =
          'Note not saved: ' + error.message;

        paint();
      });

    return request;
  }

  function refreshTheme(cart) {
    const element =
      document.getElementById('cart-config');

    const ajaxCart =
      window.Shopify &&
      Shopify.theme &&
      Shopify.theme.ajaxCart;

    if (
      !element ||
      !ajaxCart ||
      typeof ajaxCart.updateView !== 'function'
    ) {
      throw new Error(
        'Your cart was updated, but the display could not refresh. Reopen the cart to check totals.'
      );
    }

    ajaxCart.updateView(
      JSON.parse(element.textContent),
      cart
    );
  }

  document.addEventListener(
    'input',
    function (event) {
      const form =
        event.target.closest(formSelector);

      if (!form) return;

      if (event.target.matches('.qb-cart-note')) {
        noteDraft = event.target.value;

        clearTimeout(noteTimer);

        noteTimer = setTimeout(function () {
          saveNote(noteDraft).catch(function () {});
        }, 600);
      }

      if (event.target.matches('.qb-promo-input')) {
        promoDraft = event.target.value;
        promoMessage = '';
      }
    }
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.target.matches(
          formSelector + ' .qb-promo-input'
        ) &&
        event.key === 'Enter'
      ) {
        event.preventDefault();

        event.target
          .closest(formSelector)
          .querySelector('.qb-promo-apply')
          .click();
      }
    },
    true
  );

  document.addEventListener(
    'click',
    async function (event) {
      const button = event.target.closest(
        formSelector + ' .qb-promo-apply'
      );

      if (!button) return;

      event.preventDefault();

      if (promoBusy || checkoutBusy) return;

      const code = promoDraft.trim();

      if (!code) {
        promoMessage = 'Enter a promo code first.';
        paint();
        return;
      }

      promoBusy = true;
      promoMessage = 'Checking code…';
      paint();

      try {
        clearTimeout(noteTimer);

        if (noteDraft !== null) {
          await saveNote(noteDraft);
        }

        // The comma-separated value is the complete
        // manually submitted code list.
        const cart = await updateCart({
          discount: code
        });

        const applications = (
          cart.cart_level_discount_applications || []
        ).slice();

        (cart.items || []).forEach(function (item) {
          (
            item.line_level_discount_allocations || []
          ).forEach(function (allocation) {
            if (allocation.discount_application) {
              applications.push(
                allocation.discount_application
              );
            }
          });
        });

        const codes = code
          .split(',')
          .map(function (entry) {
            return entry.trim().toLowerCase();
          })
          .filter(Boolean);

        const confirmed = codes.filter(
          function (entry) {
            return applications.some(
              function (application) {
                return (
                  String(application.title || '')
                    .toLowerCase() === entry &&
                  application.type === 'discount_code'
                );
              }
            );
          }
        );

        promoMessage =
          confirmed.length === codes.length
            ? 'Code applied. Review the updated totals below.'
            : 'This code could not be confirmed for the current cart. It may be invalid, ineligible, or require verification at checkout.';

        refreshTheme(cart);
      } catch (error) {
        promoMessage = error.message;
      } finally {
        promoBusy = false;
        paint();
      }
    },
    true
  );

  // Save the latest note before checkout, without
  // submitting stale quantity fields.
  document.addEventListener(
    'submit',
    async function (event) {
      const form =
        event.target.closest(formSelector);

      if (
        !form ||
        !event.submitter ||
        event.submitter.name !== 'checkout'
      ) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (
        promoBusy ||
        checkoutBusy ||
        !form.reportValidity()
      ) {
        return;
      }

      checkoutBusy = true;
      paint();

      try {
        clearTimeout(noteTimer);

        const note =
          form.querySelector('.qb-cart-note');

        if (note) {
          noteDraft = note.value;
          await saveNote(noteDraft);
        } else {
          await noteQueue;
        }

        window.location.assign(
          root + 'checkout'
        );
      } catch (error) {
        noteMessage =
          'Unable to save your note. Please try checkout again.';
      } finally {
        checkoutBusy = false;
        paint();
      }
    },
    true
  );

  function observe() {
    const drawer = document.getElementById(
      'slideout-ajax-cart'
    );

    if (!drawer) return;

    new MutationObserver(paint).observe(
      drawer,
      {
        childList: true,
        subtree: true
      }
    );

    paint();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      observe
    );
  } else {
    observe();
  }
})();
/* Normalize only the second Apply button's label. */
(function () {
  if (window.qbCouponLabelInstalled) return;
  window.qbCouponLabelInstalled = true;

  function initializeCouponLabel() {
    const drawer = document.getElementById(
      'slideout-ajax-cart'
    );

    if (!drawer) return;

    function updateLabel() {
      drawer
        .querySelectorAll('.discountyard-apply-button')
        .forEach(function (button) {
          if (button.textContent.trim() === 'APPLY') {
            button.textContent = 'Apply';
          }
        });
    }

    updateLabel();

    new MutationObserver(updateLabel).observe(
      drawer,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeCouponLabel
    );
  } else {
    initializeCouponLabel();
  }
})();

/* Global cart entry points. Keep checkout and cart permalinks intact. */
(function () {
  if (window.qbGlobalCartLinksInstalled) return;
  window.qbGlobalCartLinksInstalled = true;
  let opening = false;

  function context() {
    const element = document.getElementById('cart-config');
    const cart = window.Shopify && Shopify.theme && Shopify.theme.ajaxCart;
    if (!element || !cart || !document.getElementById('slideout-ajax-cart')) return null;
    if (typeof cart.updateView !== 'function' || typeof cart.showDrawer !== 'function') return null;
    try {
      const config = JSON.parse(element.textContent);
      config.cart_action = 'drawer';
      return { cart: cart, config: config };
    } catch (error) {
      return null;
    }
  }

  document.addEventListener('click', function (event) {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    if (link.closest('.shopify-payment-button') || link.hasAttribute('data-qb-cart-page')) return;
    let url;
    try { url = new URL(link.href, window.location.href); } catch (error) { return; }
    if (url.origin !== window.location.origin) return;
    const state = context();
    if (!state) return;
    const cartUrl = new URL(state.config.cart_url, window.location.origin);
    // Match only the cart landing page, not /cart/add, /cart/change,
    // checkout permalinks, or links carrying actions/discount parameters.
    if (url.pathname.replace(/\/$/, '') !== cartUrl.pathname.replace(/\/$/, '')) return;
    if (url.search || url.hash) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (opening) return;
    opening = true;
    const root = Shopify.routes && Shopify.routes.root || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart refresh failed');
        return response.json();
      })
      .then(function (cart) {
        state.cart.updateView(state.config, cart);
        state.cart.showDrawer(state.config);
      })
      .catch(function () {
        // Preserve access to the cart if the drawer fails.
        window.location.assign(link.href);
      })
      .finally(function () { opening = false; });
  }, true);

  function initialize() {
    const state = context();
    if (!state || typeof state.cart.addToCart !== 'function' || state.cart.qbGlobalAddInstalled) return;
    const original = state.cart.addToCart;
    state.cart.addToCart = function (form, formContext, config, isQuickview) {
      // Retain the theme's validation, request, feedback and error handling.
      const drawerConfig = Object.assign({}, config, {
        cart_action: 'drawer',
        cart_added_event: 'go_to_active_cart'
      });
      return original.call(this, form, formContext, drawerConfig, isQuickview);
    };
    state.cart.qbGlobalAddInstalled = true;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
